var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop, Vue } from 'vue-property-decorator';
let MapDot = class MapDot extends Vue {
    onClicked(event) {
        if (event.screenX === 0 && event.screenY === 0) {
            this.$emit('onClickedWithFocus');
        }
        else {
            this.$emit('onClicked');
        }
    }
};
__decorate([
    Prop()
], MapDot.prototype, "isActive", void 0);
__decorate([
    Prop()
], MapDot.prototype, "clickable", void 0);
__decorate([
    Prop({ default: 8 })
], MapDot.prototype, "dotSize", void 0);
__decorate([
    Prop()
], MapDot.prototype, "ariaLabel", void 0);
__decorate([
    Prop()
], MapDot.prototype, "projectId", void 0);
__decorate([
    Prop()
], MapDot.prototype, "isGlobal", void 0);
MapDot = __decorate([
    Component
], MapDot);
export default MapDot;
